import { FilterX } from "lucide-react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { Button } from "@/components/ui/button"

/**
 * OKS-39 — Filtered-empty state (PRD OQ-8 / UX Spec §2).
 *
 * Renders when the brand has approved submissions in general (`is_empty`
 * false) BUT the active filter set returns zero rows. Distinct from
 * `<GalleryEmptyState>` — the CTA here is "Reset filters" (escape hatch),
 * not "Go to missions" (which would patronise an operator who already
 * has content).
 */
interface GalleryFilteredEmptyStateProps {
  onReset: () => void
}

export function GalleryFilteredEmptyState({
  onReset,
}: GalleryFilteredEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <EmptyState
      icon={FilterX}
      title={t("content_gallery.no_results.title")}
      description={t("content_gallery.no_results.helper")}
      actions={
        <Button
          type="button"
          variant="secondary"
          onClick={onReset}
          data-testid="gallery-filtered-empty-reset"
        >
          {t("content_gallery.no_results.reset_cta")}
        </Button>
      }
    />
  )
}
